/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { string } from 'prop-types';

import './style.scss';

function ServicePill({ name, ...props }) {
  return (
    <div className="service-pill-wrapper arc-p" {...props}>
      {name}
    </div>
  );
}

ServicePill.propTypes = {
  name: string.isRequired,
};

export default ServicePill;
